// removed by extract-text-webpack-plugin
module.exports = {"license":"_20MKqRLcIwXMFpLi","license-link":"_6lr_4nzTf8SzDDCB"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/common/components/subscription_form/license/index.css
// module id = 737
// module chunks = 0